import React from "react"
import Select from "react-select"
import { BrandOption } from "../../../types/BrandOption"

interface Props {
    brands: BrandOption[]
    value: BrandOption | null
    onChange: (brand: BrandOption | null) => void
    disabled?: boolean
}

export default function BrandSelect({ brands, value, onChange, disabled }: Props) {
    return (
        <div className="mb-3" style={{ maxWidth: '500px' }}>
            <label className="text-muted mb-1">
                <small>Marque</small>
            </label>
            <Select
                isClearable
                options={brands}
                value={value}
                onChange={onChange}
                placeholder="Sélectionner une marque..."
                noOptionsMessage={() => "Aucune marque trouvée"}
                disabled={disabled}
            />
        </div>
    )
}
